import { Observable } from 'rxjs';

import { InvoicesCreditDetailsResponse } from '../../model/invoices-credits.model';

export abstract class InvoiceCreditDetailsAdapter {
  abstract loadInvoiceDetails(
    documentNumber: string
  ): Observable<InvoicesCreditDetailsResponse>;
}
